import { fetch as apiFetch } from '../fetchWrapper/fetch';
import { API_URL as menuApiUrl } from '../constants';

interface ExportCSVParams {
  menuId: string;
  payload: unknown;
}

export async function exportCSV({ payload, menuId }: ExportCSVParams): Promise<Blob> {
  try {
    const response = await apiFetch(`${menuApiUrl}/menus/${menuId}/export`, {
      method: 'POST',
      body: payload ? JSON.stringify(payload) : null,
      cache: 'reload',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/csv',
      },
    });
    if (!response.ok) throw new Error(response.statusText);
    return await response.blob();
  } catch (error) {
    throw new Error('Could not export CSV', { cause: error });
  }
}
